<template>
    <div>
        <landing-page-header-hoh
                v-if="parseInt(landingPageTypeId) === LU_LP_TYPES.HOME_OWNERSHIP"
                :btn-action-callback="handleClaimMyHomeClick"
                :landing-page="landingPage"
        />
        <div class="hub-preview overflow-auto">
            <info-bar
                    border-color="#5A51DE"
                    class="info-bar-first justify-content-center"
                    color="purple"
                    icon="fa-info-circle"
            >
                <div class="d-flex justify-content-center align-items-center top-text">
                    <p class="mb-0">
                        This is a limited preview. Claim your hub to unlock full access.
                    </p>
                    <p
                            class="claim-my-home mb-0 cursor-pointer font-weight-bold"
                            @click="handleClaimMyHomeClick"
                    >
                        CLAIM MY HOME
                    </p>
                </div>
            </info-bar>

            <b-skeleton-img
                    v-if="loading"
                    class="hub-preview-canvas-loading"
            />
            <canvas
                    ref="hubPreviewCanvas"
                    :class="{
                    'w-100': windowWidth < 1100 && windowWidth !== 768 && windowWidth !== 400,
                }"
                    class="hub-preview-canvas h-auto cursor-pointer"
                    @click="handleClaimMyHomeClick"
            />
            <info-bar
                    border-color="#5A51DE"
                    class="justify-content-center"
                    color="purple"
                    icon="fa-info-circle"
            >
                <div class="d-flex justify-content-center align-items-center top-text">
                    <p class="mb-0">
                        This is a limited preview. Claim your hub to unlock full access.
                    </p>
                    <p
                            class="claim-my-home mb-0 cursor-pointer font-weight-bold"
                            @click="handleClaimMyHomeClick"
                    >
                        CLAIM MY HOME
                    </p>
                </div>
            </info-bar>
        </div>
    </div>
</template>

<script>
import './HubPreview.scss';
import './HubPreview.mobile.scss';
import InfoBar from "@milestoneslabs/milestones-ui-kit/src/components/InfoBar/InfoBar";
import {VIEW_BREAKPOINTS} from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
import QueryStrings from "@milestoneslabs/milestones-unified-login/src/QueryStrings";
import get from "lodash/get";
import {addressGeocode} from "@milestoneslabs/milestones-ui-kit/src/helpers/homeJunction";
import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
import {ALL as LU_LP_TYPES} from "@milestoneslabs/milestones-core-js/src/AppResources/LuLandingPageTypeAppResource";
import {
    SIZE_DESKTOP,
    SIZE_MOBILE,
    SIZE_TABLET
} from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageHubPreviewAppResource";
import {mapState} from "vuex";
import {newProjectUrl} from "../../../components/helpers/externalRoutes";
import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
import {HOME_OWNERSHIP} from "@milestoneslabs/milestones-core-js/src/AppResources/WorkspaceTypeAppResource";
import {
    CLAIM_YOUR_HOME_MODAL_OPEN
} from "../../../components/LandingPage/Modals/ClaimYourHomeModal/ClaimYourHomeModal";
import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
import LandingPageHeaderHoh
    from "../../../components/LandingPage/LandingPageHeader/LandingPageHeaderHOH/LandingPageHeaderHOH";
import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";
import GoogleMapsLoader from "@milestoneslabs/milestones-property-search/src/vue/classes/GoogleMapsLoader";

export default {
    name: "HubPreview",
    components: {
        InfoBar,
        LandingPageHeaderHoh,
    },
    mixins: [
        ShowNotificationMixin
    ],
    props: {
        landingPage: {
            type: LandingPageAppResource,
            required: true,
        },
    },
    data() {
        return {
            windowWidth: window.windowWidth,
            HOHProjectTypeUuid: '',
            address: {},
            loading: false,
            propImgSrc: '',
            LU_LP_TYPES,
            landingPageTypeId: window.landingPageTypeId,
            previewData: {
                [SIZE_DESKTOP]: {
                    mainImageSrc: require('../../../../assets/images/landingPages/home-ownership/hub-preview-desktop.png'),
                    addressItem: {
                        x: 760,
                        y: 20,
                    },
                    propertyImageItem: {
                        x: 980,
                        y: 40,
                    }
                },
                [SIZE_TABLET]: {
                    mainImageSrc: require('../../../../assets/images/landingPages/home-ownership/hub-preview-tablet.png'),
                    addressItem: {
                        x: 40,
                        y: 400,
                    },
                    propertyImageItem: {
                        x: 270,
                        y: 420,
                    }
                },
                [SIZE_MOBILE]: {
                    mainImageSrc: require('../../../../assets/images/landingPages/home-ownership/hub-preview-mobile.png'),
                    addressItem: {
                        x: 40,
                        y: 400
                    },
                    propertyImageItem: {
                        x: 250,
                        y: 400
                    }
                },
            }
        };
    },

    computed: {
        ...mapState({
            authUser: state => state.landingPage.authUser
        }),
    },
    methods: {
        async getHubPreviewDetails() {
            let hubPreview = new AppResourceSearch('landing-page-hub-preview');

            await hubPreview.setSearchData({
                include: [
                    'file',
                ],
                relations: {
                    landingPageType: new ApiFilter({
                        params: {
                            id: LU_LP_TYPES.HOME_OWNERSHIP,
                        }
                    }),
                },
            });

            try {
                await hubPreview.search();

                if (hubPreview.appResourceCollection.isNotEmpty) {
                    hubPreview.appResourceCollection.forEach((item) => {
                        this.previewData[item.screenSize] = {
                            mainImageSrc: window.env.MILESTONES_AUTH_HOST + '/public-file/' + item.file.uuid + '?',
                            addressItem: {
                                x: item.addressPositionX,
                                y: item.addressPositionY
                            },
                            propertyImageItem: {
                                x: item.streetViewPositionX,
                                y: item.streetViewPositionY
                            }
                        };
                    });
                }
            } catch (e) {
                console.warn(e);
            }
        },
        handleClaimMyHomeClick() {
            if (!this.HOHProjectTypeUuid) {
                return;
            }

            if (this.authUser.uuid) {
                if (this.landingPage.userUuid === this.authUser.uuid) {
                    this.showNotification({
                        message: 'You can not create a hub from your own Landing Page! Please log in as another user!',
                        type: 'error',
                    });
                    return;
                }
                window.location = newProjectUrl({
                    type: this.HOHProjectTypeUuid,
                    hohAddress: btoa(JSON.stringify(this.address)),
                    landingPageUuid: window.landingPageUuid,
                });
                return;
            }
            this.$bus.$emit(CLAIM_YOUR_HOME_MODAL_OPEN, {
                address: this.address,
                propImgSrc: this.propImgSrc,
                HOHProjectTypeUuid: this.HOHProjectTypeUuid,
                hohEmail: localStorage.getItem('hohEmail') ? localStorage.getItem('hohEmail') : '',
                landingPage: this.landingPage,
            });
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        async initHubPreview() {
            let canvas = this.$refs.hubPreviewCanvas;
            let context = canvas.getContext("2d");
            let street = '';

            if (this.address.deliveryLine) {
                street = this.address.deliveryLine;
            } else {
                street = this.address.streetNumber ? this.address.streetNumber + ' ' : '';
                street += this.address.street ? this.address.street : '';

                if (!street) {
                  street = this.address.fullAddress;
                }
            }

            let cityState = this.address.city ? this.address.city + ', ' : '';
            cityState += this.address.state ? this.address.state + ' ' : '';
            cityState += this.address.postalCode ? this.address.postalCode : '';

            const svg = `<svg width="250" height="100" xmlns="http://www.w3.org/2000/svg">
                            <foreignObject x="0" y="0" width="250" height="100">
                                <p
                                    style="font-family: Helvetica; font-size: 20px;width: 200px; overflow: hidden;
                                    text-overflow: ellipsis;white-space: nowrap;"
                                    xmlns="http://www.w3.org/1999/xhtml">
                                        ${street}
                                </p>
                            </foreignObject>
                            <foreignObject x="0" y="40" width="250" height="100">
                                <p
                                    style="font-family: Helvetica; font-size: 14px; color:#646B7E"
                                    xmlns="http://www.w3.org/1999/xhtml">
                                        ${cityState}
                                </p>
                            </foreignObject>
                        </svg>`;
            const blob = new Blob([svg], {type: 'image/svg+xml'});
            const addressURL = URL.createObjectURL(blob);

            if (this.address.coordinates) {
                let googleMapsLoader = GoogleMapsLoader.instance();
                googleMapsLoader.load();
                await googleMapsLoader.importLibrary('maps');
                await this.getPropertyImage();
            }


            let mainImageSrc = this.previewData[SIZE_DESKTOP].mainImageSrc;
            if (this.windowWidth <= VIEW_BREAKPOINTS.TABLET) {
                mainImageSrc = this.previewData[SIZE_TABLET].mainImageSrc;
            }
            if (this.windowWidth <= VIEW_BREAKPOINTS.MOBILE) {
                mainImageSrc = this.previewData[SIZE_MOBILE].mainImageSrc;
            }

            Promise.allSettled(
                [
                    this.loadImage(mainImageSrc),
                    this.loadImage(addressURL),
                    this.loadImage(this.propImgSrc)
                ]
            ).then((results) => {
                let images = [];
                results.forEach((result) => {
                    if (result.status === 'fulfilled') {
                        images.push(result.value);
                    }
                });
                let addressItem = {
                    image: images[1],
                    x: this.previewData[SIZE_DESKTOP].addressItem.x,
                    y: this.previewData[SIZE_DESKTOP].addressItem.y,
                };
                let propertyImageItem;
                if (images.hasOwnProperty(2)) {
                    propertyImageItem = {
                        image: images[2],
                        x: this.previewData[SIZE_DESKTOP].propertyImageItem.x,
                        y: this.previewData[SIZE_DESKTOP].propertyImageItem.y,
                    };
                }

                let canvasWidth = 1100;

                if (this.windowWidth <= VIEW_BREAKPOINTS.TABLET) {
                    canvasWidth = 768;
                    addressItem.x = this.previewData[SIZE_TABLET].addressItem.x;
                    addressItem.y = this.previewData[SIZE_TABLET].addressItem.y;
                    if (propertyImageItem) {
                        propertyImageItem.x = this.previewData[SIZE_TABLET].propertyImageItem.x;
                        propertyImageItem.y = this.previewData[SIZE_TABLET].propertyImageItem.y;
                    }
                }

                if (this.windowWidth <= VIEW_BREAKPOINTS.MOBILE) {
                    canvasWidth = 400;
                    addressItem.x = this.previewData[SIZE_MOBILE].addressItem.x;
                    addressItem.y = this.previewData[SIZE_MOBILE].addressItem.y;
                    if (propertyImageItem) {
                        propertyImageItem.x = this.previewData[SIZE_MOBILE].propertyImageItem.x;
                        propertyImageItem.y = this.previewData[SIZE_MOBILE].propertyImageItem.y;
                    }
                }

                // Work out the images ratio
                const imageRatio = images[0].width / images[0].height;

                // Work out the new height of the canvas, keeping in ratio with the image
                const canvasHeight = canvasWidth / imageRatio;

                // Set the canvas' height in the style tag to be correct
                canvas.style.height = canvasHeight + "px";

                // Set the width/height attributes to be correct (as this is what drawImage uses)
                canvas.width = canvasWidth;
                canvas.height = canvasHeight;

                // Draw the image at the right width/height
                context.drawImage(images[0], 0, 0, canvasWidth, canvasHeight);

                context.drawImage(addressItem.image, addressItem.x, addressItem.y);
                if (propertyImageItem) {
                    context.drawImage(propertyImageItem.image, propertyImageItem.x, propertyImageItem.y, 100, 100);
                }
            });
        },
        loadImage(url) {
            return new Promise((resolve, reject) => {
                let imageObj = new Image();
                imageObj.src = url;
                imageObj.onload = () => resolve(imageObj);
                imageObj.onerror = (errorData) => reject(errorData);
            });
        },
        async getPropertyImage() {
            let property = new PropertyAppResource({
                attributes: {
                    details: {
                        latitude: this.address.coordinates.latitude,
                        longitude: this.address.coordinates.longitude,
                    }
                }
            });
            let googlePanoramas = await property.getGooglePanorama();
            if (!googlePanoramas.length) {
                return;
            }

            try {
                let url = new URL('https://maps.googleapis.com/maps/api/streetview');
                url.searchParams.append(
                    'location',
                    this.address.coordinates.latitude + ',' + this.address.coordinates.longitude
                );
                url.searchParams.append('key', window.env.GOOGLE_API_KEY);
                url.searchParams.append('size', '100x100');
                this.propImgSrc = url.toString();
            } catch (e) {
                console.warn(e);
            }
        },
        checkAddress() {
            let hohAddress = get(this.$route.query, QueryStrings.HOH_ADDRESS, null);

            if (!hohAddress) {
                this.$router.push({name: 'landing-page.home'});
                return;
            }

            try {
                this.address = JSON.parse(atob(hohAddress));
            } catch (e) {
                console.warn(e);
            }

            if (typeof this.address !== 'object') {
                this.$router.push({name: 'landing-page.home'});
            }
            if (
                !this.address.hasOwnProperty('city') &&
                !this.address.hasOwnProperty('country') &&
                !this.address.hasOwnProperty('fullAddress') &&
                !this.address.hasOwnProperty('state') &&
                !this.address.hasOwnProperty('street') &&
                !this.address.hasOwnProperty('streetNumber')
            ) {
                this.$router.push({name: 'landing-page.home'});
            }
        },
        async setAddressCoordinates() {
            const geocode = await addressGeocode({
                deliveryLine: this.address.deliveryLine,
                city: this.address.city,
                state: this.address.state,
                zip: this.address.zip
            });
            if (geocode?.coordinates?.latitude && geocode?.coordinates?.longitude) {
                this.address.coordinates = {
                    latitude: geocode.coordinates.latitude,
                    longitude: geocode.coordinates.longitude,
                };
                this.address.latitude = geocode.coordinates.latitude;
                this.address.longitude = geocode.coordinates.longitude;
            }
            if (geocode?.address?.zip) {
                this.address.postalCode = geocode?.address?.zip;
            }

            if (geocode?.address?.deliveryLine) {
              this.address.deliveryLine = geocode?.address?.deliveryLine;
            }

            const components = geocode?.address?.components;
            if (components) {
                this.address.suffix = components.suffix;
                this.address.postDirection = components.postdirectional;
                this.address.preDirection = components.predirectional;
                this.address.streetNumber = components.primaryNumber;
                this.address.street = components.streetName;
                this.address.secondaryNumber = components.secondaryNumber;
            }
        },
        async fetchHomeOwnershipProjectType() {
            let projectTypeSearch = new AppResourceSearch('workspace-type');

            await projectTypeSearch.setSearchData({
                filter: new ApiFilter({
                    params: {
                        type: HOME_OWNERSHIP,
                    },
                }),
            });

            try {
                await projectTypeSearch.search();

                if (projectTypeSearch.appResourceCollection.isNotEmpty) {
                    let item = projectTypeSearch.appResourceCollection.getFirst();
                    this.HOHProjectTypeUuid = item.uuid;
                }
            } catch (e) {
                console.warn(e);
            }
        },

    },
    watch: {
        async windowWidth(newVal, oldVal) {
            if (oldVal > VIEW_BREAKPOINTS.TABLET && newVal <= VIEW_BREAKPOINTS.TABLET) {
                await this.initHubPreview();
            }
            if (oldVal <= VIEW_BREAKPOINTS.TABLET && newVal > VIEW_BREAKPOINTS.TABLET) {
                await this.initHubPreview();
            }
            if (oldVal > VIEW_BREAKPOINTS.MOBILE && newVal <= VIEW_BREAKPOINTS.MOBILE) {
                await this.initHubPreview();
            }
            if (oldVal <= VIEW_BREAKPOINTS.MOBILE && newVal > VIEW_BREAKPOINTS.MOBILE) {
                await this.initHubPreview();
            }
        }
    },
    async mounted() {
        let url = new URL(window.env.MILESTONES_AUTH_HOST);

        if (window.location.host !== url.host) {
            let address = window.location.protocol + '//' +
                url.host +
                window.location.pathname +
                window.location.search;
            window.location = address;
        }
        this.loading = true;
        this.fetchHomeOwnershipProjectType();
        await this.getHubPreviewDetails();

        this.checkAddress();

        if (this.address.street) {
            await this.setAddressCoordinates();
        }

        await this.initHubPreview();
        this.loading = false;
    },
    created() {
        window.addEventListener('resize', this.onResize);
        this.onResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize);
    },
};
</script>
